// import React, { useState, useEffect, useCallback } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import "./TutorExam.css";
// import Button from "@mui/material/Button";
// import { axiosClient } from "../../../../utils/auth.util";
// import { useDispatch, useSelector } from "react-redux";
// import { setExamObj } from "../../../../redux/slice/tutorExamSlice";

// const hasPassedExam = localStorage.getItem("hasPassedExam");

// const TutorExamEnd = (props) => {
//   const [isPage, setIsPage] = useState(true);
//   const history = useNavigate();
//   const from = useSelector((state) => state.exam.from);
//   const examObj = useSelector((state) => state.exam.examObj);
//   console.log("checking from", from);
//   // Extract the values from props or fallback to examObj
//   const [examId, setExamId] = useState('')
//   const [subject, setSubject] = useState('')
//   const [marks, setMarks] = useState('')
//   const [resultStatus, setResultStatus] = useState('')

//   // let examId = props.examId
//   // let subject = props.subject
//   // let marks = (+props.result) * 4;
//   // let resultStatus = props.resultStatus

//   const dispatch = useDispatch();

//   const dashboardEntry = async () => {
//     let tutor1 = JSON.parse(localStorage.getItem("tutor"));
//     let tutor_ls = JSON.parse(localStorage.getItem("tutor")).saveTutor;


//     let temp_tutorSaveObj = {
//       ...tutor_ls,
//       tutStatus: "db",
//     };
//     console.log({ tutor_ls });
//     let temp_tutorObj = {
//       ...tutor1,
//       saveTutor: temp_tutorSaveObj,
//     };
//     let tutor_stringified = JSON.stringify(temp_tutorObj);
//     localStorage.setItem("tutor", tutor_stringified);

//     const res = await axiosClient.post(
//       `/tutorweb/setTutStatus/${JSON.parse(localStorage.getItem("tutor")).saveTutor.tutor_id}`,
//       { tutStatus: "db" }
//     );
//     if (res.data) {
//       history("/register-dashboard",{replace:true});
//       // window.location.reload();
//     } else {
//       console.log("not saved tutStatus in db");
//     }
//   };

//   const tryAnotherExam = async () => {
//     if (resultStatus === 'pass') {
//       const setTutStatus = await axiosClient.post(
//         `/tutorweb/setTutStatus/${JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutor_id}`,
//         { tutStatus: "subs" }
//       );
//       if (setTutStatus.data) {
//         history("/register-dashboard/tutor_exam/subjective_sheet",{replace:true});
//         // window.location.reload();
//       }

//     }
//   };

//   const anotherExam = async () => {
//     //////
//     const setTutStatus = await axiosClient.post(
//       `/tutorweb/setTutStatus/${JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutor_id}`,
//       { tutStatus: "mcqs" }
//     );
//     if (setTutStatus.data) {
//       history("/register-dashboard/tutor_exam",{replace:true});
//       window.location.reload();
//     }

//   };

//   const saveInTutorMain = async () => {
//     const tutorInfo = JSON.parse(
//       window.localStorage.getItem("tutor")
//     )?.saveTutor;
//     const tutorRatingVal = await axiosClient.get(
//       `/tutorweb/getTutorRating/${JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutor_id}`
//     );
//     // props.setTemp_tutExam(temp_tutorObj)
//     const ratingVal = tutorRatingVal?.data?.ratingVal;
//     let marksVal = marks * 4
//     let initialRating = ratingVal
//       ? marksVal > 70 && marksVal <= 75
//         ? (+ratingVal + 6) / 2
//         : marksVal > 75 && marksVal <= 80
//           ? (+ratingVal + 7) / 2
//           : marksVal > 80 && marksVal <= 85
//             ? (+ratingVal + 8) / 2
//             : marksVal > 85 && marksVal <= 90
//               ? (+ratingVal + 9) / 2
//               : marksVal > 90 && (+ratingVal + 10) / 2
//       : marksVal > 70 && marksVal <= 75
//         ? 6
//         : marksVal > 75 && marksVal <= 80
//           ? 7
//           : marksVal > 80 && marksVal <= 85
//             ? 8
//             : marksVal > 85 && marksVal <= 90
//               ? 9
//               : marksVal > 90 && 10;
//     // console.log({tutorRatingVal , marksVal , initialRating})
//     let postData1 = {
//       tutor_id: tutorInfo?.tutor_id,
//       name: tutorInfo?.name,
//       email: tutorInfo?.email,
//       dept: tutorInfo?.dept,
//       rating: initialRating ? initialRating?.toFixed(2) + "" : null,
//       highest_degree: tutorInfo?.highest_degree,
//       university: tutorInfo?.academic_info[0]?.college,
//       watsNumber: tutorInfo?.wa_id,
//       writer: tutorInfo?.writer,
//       tags: subject,
//     };
//     const updateTutorInfo = await axiosClient.post(
//       `/tutorweb/updateTutorInfoWithRating/${JSON.parse(window.localStorage.getItem("tutor")).saveTutor.tutor_id}`,
//       postData1
//     );
//     // `http://localhost:8800/api/tutorweb/updateTutorInfo/${JSON.parse(window.localStorage.getItem("tutor")).saveTutor.tutor_id}`,postData1)
//     if (updateTutorInfo.data) {
//       console.log({
//         testTagsDev1: JSON.parse(localStorage.getItem("tutor"))?.saveTutor
//           ?.tutor_exam[-1]?.subject,
//       });
//       console.log("updated the tutor database");
//     } else {
//       console.log("tutor database not updated");
//     }
//   };
//   const find_examId = useCallback(async () => {
//     const response = await axiosClient.post(
//       "/tutorweb/find_examId",
//       {
//         tutorId: JSON.parse(localStorage.getItem("tutor")).saveTutor.tutor_id,
//       }
//     );

//     if (response.status === 201 || response.status === 200) {
//       console.log(response.data.tutStatus, "<<<< tut status");
//       let status = response.data.tutStatus
//       let obj
//       if (response.data.lastExamId) {
//         obj = response.data.tutor_exam.find(exam => exam.exam_id === response.data.lastExamId)
//         console.log('✌️obj --->', obj);
//         dispatch(setExamObj(obj))
//         if (status === 'mcqe') {
//           setExamId(response.data.lastExamId)
//           setSubject(obj.subject)
//           setMarks((+obj.mcq_marks))
//           setResultStatus(obj.mcqStatus)
//           // examId = response.data.lastExamId;
//           // subject = obj.subject
//           // marks = (+obj.mcqMarks) * 4;
//           // resultStatus = obj.mcqStatus
//         }
//         else if (status === 'subs') {
//           history('/register-dashboard/tutor_exam/subjective_sheet',{replace:true})
//         }
//         else if (status === 'intrvfm' || status === 'intrvreg' || status == 'intrvres') {
//           history(`/register-dashboard/tutor_exam/interviews/?status=${status}`,{replace:true})
//         }
//         else {
//           history('/register-dashboard/tutor_exam',{replace:true})
//         }
//       }

//     }
//   }, []);

//   useEffect(() => {
//     find_examId()
//   }, [])

//   useEffect(() => {
//     if (!subject || !marks || !examId || !resultStatus) {
//       console.log({ subjectCheck: subject });
//       // setIsPage(false);
//     } else {
//       if (
//         JSON.parse(window.localStorage.getItem("tutor")).saveTutor.tutStatus ==
//         "db" ||
//         JSON.parse(window.localStorage.getItem("tutor")).saveTutor.tutStatus ==
//         "exl"
//       ) {
//         saveInTutorMain();
//       }
//       setIsPage(true);
//     }
//   }, [subject, marks, examId, resultStatus]);

//   return (
//     <div>
//       {isPage && (
//         <div
//           role="main"
//           class="form-all form-desc-end"
//         // style={{ marginLeft: "27%", marginTop: "11rem", width: "50%" }}
//         >
//           <ul class="form-section page-section">
//             <li id="cid_1" class="form-input-wide" data-type="control_head">
//               <div class="form-header-group  header-default">
//                 <div class="header-text httac htvam">
//                   <h2
//                     id="header_1"
//                     class="form-header"
//                     data-component="header"
//                     style={{ textAlign: "center" }}
//                   >
//                     Tutor Registration Test
//                   </h2>
//                 </div>
//               </div>
//             </li>
//             <li>
//               <div id="cid_13" class="form-input-wide">
//                 <div id="text_13" class="form-html" data-component="text">
//                   <div
//                     style={{ textAlign: "center", justifyContent: "center" }}
//                   >
//                     <strong style={{ color: "darkorange" }}>
//                       You have successfully submitted
//                     </strong>
//                     <div
//                       style={{
//                         marginTop: "10%",
//                         marginBottom: "5%",
//                         backgroundColor: "#f2ffff",
//                       }}
//                     >
//                       <div
//                         style={{ display: "flex", justifyContent: "center" }}
//                       >
//                         <span style={{ flex: "50%" }}> Exam Id : </span>
//                         <p style={{ flex: "50%" }}>{examId}</p>
//                       </div>
//                       <div
//                         style={{ display: "flex", justifyContent: "center" }}
//                       >
//                         <span style={{ flex: "50%" }}> Subject : </span>
//                         <p style={{ flex: "50%" }}>{subject}</p>
//                       </div>
//                       <div
//                         style={{ display: "flex", justifyContent: "center" }}
//                       >
//                         <span style={{ flex: "50%" }}> Marks : </span>
//                         <p style={{ flex: "50%" }}>{(marks * 4)}/100</p>
//                       </div>
//                       <div
//                         style={{ display: "flex", justifyContent: "center" }}
//                       >
//                         <span style={{ flex: "50%" }}> Status : </span>{" "}
//                         <p
//                           style={{
//                             color:
//                               resultStatus === "fail" ? "red" : "green",
//                             flex: "50%",
//                           }}
//                         >
//                           {resultStatus}
//                         </p>
//                       </div>
//                     </div>

//                     {resultStatus === "fail" && (
//                       <span style={{ color: "red" }}>
//                         Sorry,You are not able to qualify this test. Good luck
//                         for next time!!
//                         <div
//                           style={{
//                             marginTop: "10px",
//                             marginBottom: "30px",
//                             textAlign: "center",
//                           }}
//                         >
//                           <Button
//                             variant="contained"
//                             className="ctaBtn"
//                             onClick={anotherExam}
//                             style={{
//                               background: "#03d6d7",
//                               borderRadius: "35px",
//                               fontSize: "15px",
//                             }}
//                           >
//                             Try Another Subject
//                           </Button>
//                         </div>
//                       </span>
//                     )}
//                     {resultStatus === "pass" && (
//                       <span style={{ color: "green" }}>
//                         Congrats!! You have qualified this test
//                         <div
//                           style={{
//                             marginTop: "10px",
//                             marginBottom: "30px",
//                             textAlign: "center",
//                           }}
//                         >
//                           <Button
//                             variant="contained"
//                             className="ctaBtn"
//                             onClick={tryAnotherExam}
//                             style={{
//                               background:
//                                 "linear-gradient(127deg, #03D757, #11A1DC)",
//                               borderRadius: "35px",
//                               fontSize: "15px",
//                             }}
//                           >
//                             {resultStatus === 'pass' ? "Go To Subjective" : "Dashborad"}
//                           </Button>
//                         </div>
//                       </span>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </li>

//             <li style={{ display: "none" }}>
//               Should be Empty:
//               <input type="text" name="website" value="" />
//             </li>
//           </ul>
//         </div>
//       )}

//       {!isPage && (
//         <div style={{ textAlign: "center", marginTop: "10%" }}>
//           <h1 style={{ color: "black" }}>404</h1>
//           <h1 style={{ color: "black" }}>Not Found</h1>
//           <br />
//           <h3 style={{ color: "black" }}>Invalid Grant!!</h3>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TutorExamEnd;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { updateUserData } from "../../../../redux/slice/registerSlice";
import TutorExamEndDialog from "./TutorExamEndDialog";
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
  Grid,
  Card,
  CardContent,
  Chip,
  Alert
} from "@mui/material";
import {
  CheckCircle,
  Cancel,
  Assessment,
  School,
  Timer
} from "@mui/icons-material";

const TutorExamEnd = (props) => {
  const [showDialog, setShowDialog] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // Get userData from Redux instead of localStorage
  const userData = useSelector(state => state.register.userData);

  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  const goToDashboard = () => {
    dispatch(updateUserData({ tutStatus: "db" }));
    navigate("/register-dashboard", { replace: true });
  };

  const retakeExam = () => {
    navigate("/register-dashboard/tutor_exam", { replace: true });
    window.location.reload();
  };

  const getStatusColor = (status) => {
    return status === "pass" ? "success" : "error";
  };

  const getStatusIcon = (status) => {
    return status === "pass" ? <CheckCircle /> : <Cancel />;
  };

  const calculatePercentage = (result) => {
    return (+result * 4);
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {showDialog && (
        <TutorExamEndDialog
          result={props.result}
          resultStatus={props.resultStatus}
          subject={props.subject}
          examId={props.examId}
          userData={userData}
          onClose={handleCloseDialog}
        />
      )}

      {!showDialog && (
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box textAlign="center" mb={4}>
            <Typography variant="h3" component="h1" gutterBottom>
              Exam Completed
            </Typography>
            <Typography variant="h6" color="text.secondary">
              Thank you for taking the assessment
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {/* Result Summary Card */}
            <Grid item xs={12}>
              <Card elevation={2}>
                <CardContent>
                  <Box display="flex" alignItems="center" mb={2}>
                    <Assessment color="primary" sx={{ mr: 1 }} />
                    <Typography variant="h5">
                      Exam Results
                    </Typography>
                  </Box>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <strong>Exam ID:</strong> {props.examId}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <strong>Subject:</strong> {props.subject}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <strong>Score:</strong> {calculatePercentage(props.result)}/100
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box display="flex" alignItems="center">
                        <Typography variant="body1" sx={{ mr: 1 }}>
                          <strong>Status:</strong>
                        </Typography>
                        <Chip
                          icon={getStatusIcon(props.resultStatus)}
                          label={props.resultStatus?.toUpperCase()}
                          color={getStatusColor(props.resultStatus)}
                          variant="outlined"
                        />
                      </Box>
                    </Grid>
                  </Grid>

                  <Box mt={3}>
                    {props.resultStatus === "pass" ? (
                      <Alert severity="success">
                        Congratulations! You have successfully passed the examination.
                        You can now proceed to the next step in your registration process.
                      </Alert>
                    ) : (
                      <Alert severity="error">
                        Unfortunately, you did not meet the passing requirements.
                        You can try again with a different subject or retake this exam later.
                      </Alert>
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            {/* Candidate Information */}
            <Grid item xs={12}>
              <Card elevation={2}>
                <CardContent>
                  <Box display="flex" alignItems="center" mb={2}>
                    <School color="primary" sx={{ mr: 1 }} />
                    <Typography variant="h5">
                      Candidate Information
                    </Typography>
                  </Box>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <strong>Name:</strong> {userData?.fullName || userData?.name || 'N/A'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <strong>Email:</strong> {userData?.email || 'N/A'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <strong>Department:</strong> {userData?.department || 'N/A'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <strong>Degree:</strong> {userData?.highest_degree || 'N/A'}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Action Buttons */}
          <Box mt={4} display="flex" justifyContent="center" gap={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={goToDashboard}
              sx={{ px: 4, py: 1.5 }}
            >
              Return to Dashboard
            </Button>
            
            {props.resultStatus === "fail" && (
              <Button
                variant="outlined"
                color="secondary"
                onClick={retakeExam}
                sx={{ px: 4, py: 1.5 }}
              >
                Try Another Subject
              </Button>
            )}
          </Box>

          {/* Next Steps Information */}
          <Box mt={4}>
            <Card elevation={1}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  What's Next?
                </Typography>
                {props.resultStatus === "pass" ? (
                  <Typography variant="body2" color="text.secondary">
                    Great job! You've successfully completed the academic assessment. 
                    Return to your dashboard to continue with the next steps in your 
                    tutor registration process.
                  </Typography>
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    Don't worry! You can attempt the exam again with a different subject 
                    or retake this exam after some preparation. Each subject has different 
                    questions, so you might find another subject more suitable to your expertise.
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Box>
        </Paper>
      )}
    </Container>
  );
};

export default TutorExamEnd;
